// @flow

import React, { type Node } from 'react';
import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';
import { InformationBox } from '../../../../../organisms/information-box';
import { Separator } from '@tectonics/look-and-feel/volcanes/atoms';

export function SafetypayOnlineInfo(): Node {
  const allFeatures = useAllFeatures();

  return (
    <>
      <IfFeature allFeatures={allFeatures} wanted="display_safetypay_online_pe_instructions">
        <InformationBox>
          Bancas disponibles: <strong>BCP, BBVA, Interbank, Scotiabank, Caja Arequipa, Caja Tacna</strong> y <strong>
          Caja Trujillo</strong>.
          <Separator direction="vertical" size={3}/>
          Recuerda que tienes hasta 72 horas para realizar tu pago.
        </InformationBox>
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="display_safetypay_online_ec_other_methods_tip">
        <InformationBox>
          En caso de no poder realizar tu pago con el método que elegiste, tendrás siempre la opción de generar un nuevo
          pedido y pagar con Efectivo.
        </InformationBox>
      </IfFeature>
    </>
  );
}
